<div class="div-title">
  <h1 mat-dialog-title>Configurar Importação de CSV</h1>
</div>

<div class="fields" mat-dialog-content>
  <div class="config-section" *ngIf="carregando">
    <div style="text-align: center; padding: 20px;">
      <mat-spinner diameter="40" style="margin: 0 auto;"></mat-spinner>
      <p>Carregando padrões...</p>
    </div>
  </div>

  <div class="config-section" *ngIf="!carregando && padroes.length === 0">
    <div style="text-align: center; padding: 20px;">
      <mat-icon style="font-size: 48px; height: 48px; width: 48px; color: #999;">info</mat-icon>
      <p style="color: #666; margin-top: 10px;">Nenhum padrão de importação cadastrado.</p>
      <p style="color: #666; font-size: 14px;">Cadastre um padrão em "Configurações".</p>
    </div>
  </div>

  <div class="config-section" *ngIf="!carregando && padroes.length > 0">
    <h3>📋 Padrão de Importação</h3>
    
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Padrão de Importação</mat-label>
      <mat-select [(ngModel)]="padraoSelecionado">
        <mat-option *ngFor="let padrao of padroes" [value]="padrao">
          {{ padrao.noInstituicao }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="config-section" *ngIf="!carregando && padroes.length > 0">
    <h3>📁 Arquivo CSV</h3>
    <div class="file-upload">
      <input type="file" 
             #fileInput 
             (change)="onFileSelected($event)" 
             accept=".csv" 
             style="display: none;">
      <button mat-raised-button color="primary" class="upload-button" (click)="fileInput.click()">
        <mat-icon>upload</mat-icon>
        Selecionar Arquivo CSV
      </button>
      <span class="selected-file" *ngIf="nomeArquivo">{{ nomeArquivo }}</span>
    </div>
  </div>
</div>

<div class="div-buttons" mat-dialog-actions>
  <button class="btn" mat-raised-button color="primary" 
          [disabled]="!isValid()" 
          (click)="confirmar()">
    <mat-icon>check_circle</mat-icon>
    Processar CSV
  </button>
  <button class="btn" mat-button (click)="cancelar()">
    <mat-icon>cancel</mat-icon>
    Cancelar
  </button>
</div>
